export const oneSecond = 1000;
